import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const MaxFeePerGasPropsSchema = z.object({
  maxPriorityFeePerGas: z.instanceof(HexNumber),
})

type MaxPriorityFeePerGasProps = z.infer<typeof MaxFeePerGasPropsSchema>

export class MaxPriorityFeePerGas extends ValueObject<MaxPriorityFeePerGasProps> {
  /**
   * @returns A 0x-prefixed hex string.
   */
  public getValue(): string {
    return this.props.maxPriorityFeePerGas.getValue()
  }

  public static create(maxPriorityFeePerGas: HexNumber): MaxPriorityFeePerGas {
    const validatedProps = MaxFeePerGasPropsSchema.parse({
      maxPriorityFeePerGas,
    })
    return new MaxPriorityFeePerGas(validatedProps)
  }
}
